import { SequenceHelper } from "@swivl-mono/helpers";
import {
  FMSLeadAddToAbandonedCartSequenceStrategy,
  FMSType,
  LocationVarKey,
  SequenceEnabledStatus,
  SequenceInterface,
  SequenceSubType
} from "@swivl-mono/types";
import { OptionsHelper } from "@swivl-mono/ui";
import { useEffect, useMemo } from "react";

import { IF_ALL, IF_ANY, IS_EQUAL, IS_NOT_EQUAL } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  InputRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";
import SequencesModel from "../../../../Models/Sequences/SequencesModel";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.WantsCronReceiptsAbandonedCarts,
  LocationVarKey.HasFMSPlusAbandonedCartNotes,
  LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled,
  LocationVarKey.EnableAbandonedCartSequence,
  LocationVarKey.SequenceAbandonedCartDay00Enabled,
  LocationVarKey.SequenceAbandonedCartDay00MinTime,
  LocationVarKey.SequenceAbandonedCartDay00MaxTime,
  LocationVarKey.FMSplus0AbandonedCartVoiceEnabled,
  LocationVarKey.FMSplus0AbandonedCartSMSEnabled,
  LocationVarKey.FMSplus0AbandonedCartSMSShortlink,
  LocationVarKey.FMSplus0AbandonedCartEmailEnabled,
  LocationVarKey.FMSplus0AbandonedCartEmailShortlink,
  LocationVarKey.FMSplus0AbandonedCartVoiceMessage,
  LocationVarKey.FMSplushas0AbandonedCart1,
  LocationVarKey.FMSplushas0AbandonedCart2,
  LocationVarKey.FMSplus0AbandonedCart2Shortlink,
  LocationVarKey.SequenceAbandonedCartDay01ActuallyEnabled,
  LocationVarKey.SequenceAbandonedCartDay01Time,
  LocationVarKey.FMSplusp1AbandonedCartVoiceEnabled,
  LocationVarKey.FMSplusp1AbandonedCartSMSEnabled,
  LocationVarKey.FMSplusp1AbandonedCartSMSShortlink,
  LocationVarKey.FMSplusp1AbandonedCartEmailEnabled,
  LocationVarKey.FMSplusp1AbandonedCartEmailShortlink,
  LocationVarKey.FMSplusp1AbandonedCartVoiceMessage,
  LocationVarKey.FMSplushasp1AbandonedCart1,
  LocationVarKey.FMSplushasp1AbandonedCart2,
  LocationVarKey.FMSplusp1AbandonedCart2Shortlink,
  LocationVarKey.SequenceAbandonedCartDay02Enabled,
  LocationVarKey.SequenceAbandonedCartDay02Time,
  LocationVarKey.FMSplusp2AbandonedCartVoiceEnabled,
  LocationVarKey.FMSplusp2AbandonedCartSMSEnabled,
  LocationVarKey.FMSplusp2AbandonedCartSMSShortlink,
  LocationVarKey.FMSplusp2AbandonedCartEmailEnabled,
  LocationVarKey.FMSplusp2AbandonedCartEmailShortlink,
  LocationVarKey.FMSplusp2AbandonedCartVoiceMessage,
  LocationVarKey.FMSplushasp2AbandonedCart1,
  LocationVarKey.FMSplushasp2AbandonedCart2,
  LocationVarKey.FMSplusp2AbandonedCart2Shortlink,
  LocationVarKey.SequenceAbandonedCartDay03Enabled,
  LocationVarKey.SequenceAbandonedCartDay03Time,
  LocationVarKey.FMSplusp3AbandonedCartVoiceEnabled,
  LocationVarKey.FMSplusp3AbandonedCartSMSEnabled,
  LocationVarKey.FMSplusp3AbandonedCartSMSShortlink,
  LocationVarKey.FMSplusp3AbandonedCartEmailEnabled,
  LocationVarKey.FMSplusp3AbandonedCartEmailShortlink,
  LocationVarKey.FMSplusp3AbandonedCartVoiceMessage,
  LocationVarKey.FMSplushasp3AbandonedCart1,
  LocationVarKey.FMSplushasp3AbandonedCart2,
  LocationVarKey.FMSplusp3AbandonedCart2Shortlink,
  LocationVarKey.SequenceAbandonedCartDay05Enabled,
  LocationVarKey.SequenceAbandonedCartDay05Time,
  LocationVarKey.FMSplusp5AbandonedCartVoiceEnabled,
  LocationVarKey.FMSplusp5AbandonedCartSMSEnabled,
  LocationVarKey.FMSplusp5AbandonedCartSMSShortlink,
  LocationVarKey.FMSplusp5AbandonedCartEmailEnabled,
  LocationVarKey.FMSplusp5AbandonedCartEmailShortlink,
  LocationVarKey.FMSplusp5AbandonedCartVoiceMessage,
  LocationVarKey.FMSplushasp5AbandonedCart1,
  LocationVarKey.FMSplushasp5AbandonedCart2,
  LocationVarKey.FMSplusp5AbandonedCart2Shortlink,
  LocationVarKey.SequenceAbandonedCartDay07Enabled,
  LocationVarKey.SequenceAbandonedCartDay07Time,
  LocationVarKey.FMSplusp7AbandonedCartVoiceEnabled,
  LocationVarKey.FMSplusp7AbandonedCartSMSEnabled,
  LocationVarKey.FMSplusp7AbandonedCartSMSShortlink,
  LocationVarKey.FMSplusp7AbandonedCartEmailEnabled,
  LocationVarKey.FMSplusp7AbandonedCartEmailShortlink,
  LocationVarKey.FMSplusp7AbandonedCartVoiceMessage,
  LocationVarKey.FMSplushasp7AbandonedCart1,
  LocationVarKey.FMSplushasp7AbandonedCart2,
  LocationVarKey.FMSplusp7AbandonedCart2Shortlink,
  LocationVarKey.SequenceAbandonedCartDay10Enabled,
  LocationVarKey.SequenceAbandonedCartDay10Time,
  LocationVarKey.FMSplusp10AbandonedCartVoiceEnabled,
  LocationVarKey.FMSplusp10AbandonedCartSMSEnabled,
  LocationVarKey.FMSplusp10AbandonedCartSMSShortlink,
  LocationVarKey.FMSplusp10AbandonedCartEmailEnabled,
  LocationVarKey.FMSplusp10AbandonedCartEmailShortlink,
  LocationVarKey.FMSplusp10AbandonedCartVoiceMessage,
  LocationVarKey.FMSplushasp10AbandonedCart1,
  LocationVarKey.FMSplushasp10AbandonedCart2,
  LocationVarKey.FMSplusp10AbandonedCart2Shortlink,
  LocationVarKey.SequenceAbandonedCartDay14Enabled,
  LocationVarKey.SequenceAbandonedCartDay14Time,
  LocationVarKey.FMSplusp14AbandonedCartVoiceEnabled,
  LocationVarKey.FMSplusp14AbandonedCartSMSEnabled,
  LocationVarKey.FMSplusp14AbandonedCartSMSShortlink,
  LocationVarKey.FMSplusp14AbandonedCartEmailEnabled,
  LocationVarKey.FMSplusp14AbandonedCartEmailShortlink,
  LocationVarKey.FMSplusp14AbandonedCartVoiceMessage,
  LocationVarKey.FMSplushasp14AbandonedCart1,
  LocationVarKey.FMSplushasp14AbandonedCart2,
  LocationVarKey.FMSplusp14AbandonedCart2Shortlink,
  LocationVarKey.SequenceAbandonedCartDay30Enabled,
  LocationVarKey.SequenceAbandonedCartDay30Time,
  LocationVarKey.FMSplusp30AbandonedCartVoiceEnabled,
  LocationVarKey.FMSplusp30AbandonedCartSMSEnabled,
  LocationVarKey.FMSplusp30AbandonedCartSMSShortlink,
  LocationVarKey.FMSplusp30AbandonedCartEmailEnabled,
  LocationVarKey.FMSplusp30AbandonedCartEmailShortlink,
  LocationVarKey.FMSplusp30AbandonedCartVoiceMessage,
  LocationVarKey.FMSplushasp30AbandonedCart1,
  LocationVarKey.FMSplushasp30AbandonedCart2,
  LocationVarKey.FMSplusp30AbandonedCart2Shortlink
];

export default function WorksheetView() {
  const { sequences } = SequencesModel.useState();
  const page = usePropertiesGetLocationIds();
  useEffect(() => {
    SequencesModel.load(false);
  }, []);
  const sequenceArray: SequenceInterface[] | undefined = useMemo(() => {
    if (sequences) {
      return Object.values(sequences);
    }
    return undefined;
  }, [sequences]);

  return (
    <>
      <PageHeader
        {...page}
        subheading="These sync with your FMS daily and will trigger a workflow to communicate with your leads who express interest in a unit but haven't rented."
      >
        Abandoned Cart Sequences
      </PageHeader>
      <SwitchRow {...page} keyName={LocationVarKey.WantsCronReceiptsAbandonedCarts} label="Send Email Receipts" />
      <SwitchRow
        {...page}
        hideIf={IF_ALL([
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SiteLink),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SSMCloud),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.QuikStor),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.Monument),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.Yardi)
        ])}
        keyName={LocationVarKey.HasFMSPlusAbandonedCartNotes}
        label="Add FMS Notes"
      />
      <SwitchRow {...page} keyName={LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled} label="Use Shortlinks" />
      <DropdownRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge)}
        marginTop
        label="StorEdge Scheduling Strategy"
        keyName={LocationVarKey.EnableAbandonedCartSequence}
        options={[
          {
            label: "None",
            value: ""
          },
          {
            label: "Origination is Lead",
            value: FMSLeadAddToAbandonedCartSequenceStrategy.ORIGINATION_IS_LEAD
          }
        ]}
      />
      <SwitchRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SiteLink)}
        marginTop
        label="Follow up with all leads in Lead to Lease"
        tooltip="When disabled, we will only follow up with swivl-generated leads. When enabled, we will follow up with all leads in the Lead to Lease section of Sitelink."
        keyName={LocationVarKey.EnableAbandonedCartSequence}
      />
      <SwitchRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SSMCloud)}
        marginTop
        label="Follow up with all inquiries in SSM Cloud"
        tooltip="When disabled, we will only follow up with swivl-generated leads. When enabled, we will follow up with all open inquiries in SSM Cloud."
        keyName={LocationVarKey.EnableAbandonedCartSequence}
      />
      <SwitchRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.Cubby)}
        marginTop
        label="Follow up with all leads in Cubby"
        tooltip="When disabled, we will only follow up with swivl-generated leads. When enabled, we will follow up with all open leads in Cubby."
        keyName={LocationVarKey.EnableAbandonedCartSequence}
      />
      <SwitchRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.QuikStor)}
        marginTop
        label="Follow up with all leads in QuikStor"
        tooltip="When disabled, we will only follow up with swivl-generated leads. When enabled, we will follow up with all open leads in QuikStor."
        keyName={LocationVarKey.EnableAbandonedCartSequence}
      />
      <SwitchRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.Tenant)}
        marginTop
        label="Follow up with all leads in Tenant"
        tooltip="When disabled, we will only follow up with swivl-generated leads. When enabled, we will follow up with all open leads in Tenant (Hummingbird)."
        keyName={LocationVarKey.EnableAbandonedCartSequence}
      />
      <SwitchRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.Monument)}
        marginTop
        label="Follow up with all leads in Monument"
        tooltip="When disabled, we will only follow up with swivl-generated leads. When enabled, we will follow up with all open leads in Monument."
        keyName={LocationVarKey.EnableAbandonedCartSequence}
      />

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_00, sequenceArray) && (
        <>
          <SectionHeader {...page}>Day of abandoned cart</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay00Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay00Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Send Between Start"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay00MinTime}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <DropdownRow
              {...page}
              label="Send Between End"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay00MaxTime}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplus0AbandonedCartVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplus0AbandonedCartSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplus0AbandonedCartSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplus0AbandonedCartSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplus0AbandonedCartEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplus0AbandonedCartEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplus0AbandonedCartEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplus0AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplus0AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplus0AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushas0AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushas0AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushas0AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplus0AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushas0AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_01, sequenceArray) && (
        <>
          <SectionHeader {...page}>1 day after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay01ActuallyEnabled}
            options={[
              { label: "Enabled", value: "ENABLED" },
              { label: "Disabled", value: "DISABLED" },
              { label: "Simulated", value: "SIMULATED" }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay01Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay01Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp1AbandonedCartVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp1AbandonedCartSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp1AbandonedCartSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp1AbandonedCartSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp1AbandonedCartEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp1AbandonedCartEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp1AbandonedCartEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp1AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp1AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp1AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp1AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp1AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp1AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp1AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp1AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_02, sequenceArray) && (
        <>
          <SectionHeader {...page}>2 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay02Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay02Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay02Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp2AbandonedCartVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp2AbandonedCartSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp2AbandonedCartSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp2AbandonedCartSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp2AbandonedCartEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp2AbandonedCartEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp2AbandonedCartEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp2AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp2AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp2AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp2AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp2AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp2AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp2AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp2AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_03, sequenceArray) && (
        <>
          <SectionHeader {...page}>3 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay03Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay03Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay03Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp3AbandonedCartVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp3AbandonedCartSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp3AbandonedCartSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp3AbandonedCartSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp3AbandonedCartEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp3AbandonedCartEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp3AbandonedCartEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp3AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp3AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp3AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp3AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp3AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp3AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp3AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp3AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_05, sequenceArray) && (
        <>
          <SectionHeader {...page}>5 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay05Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay05Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay05Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp5AbandonedCartVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp5AbandonedCartSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp5AbandonedCartSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp5AbandonedCartSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp5AbandonedCartEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp5AbandonedCartEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp5AbandonedCartEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp5AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp5AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp5AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp5AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp5AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp5AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp5AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp5AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_07, sequenceArray) && (
        <>
          <SectionHeader {...page}>7 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay07Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay07Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay07Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp7AbandonedCartVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp7AbandonedCartSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp7AbandonedCartSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp7AbandonedCartSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp7AbandonedCartEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp7AbandonedCartEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp7AbandonedCartEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp7AbandonedCartVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp7AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp7AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp7AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp7AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp7AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp7AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp7AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_10, sequenceArray) && (
        <>
          <SectionHeader {...page}>10 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay10Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay10Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay10Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp10AbandonedCartVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp10AbandonedCartSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp10AbandonedCartSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp10AbandonedCartSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp10AbandonedCartEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp10AbandonedCartEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp10AbandonedCartEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp10AbandonedCartVoiceEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")
              ])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp10AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp10AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp10AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp10AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp10AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp10AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp10AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_14, sequenceArray) && (
        <>
          <SectionHeader {...page}>14 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay14Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay14Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay14Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp14AbandonedCartVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp14AbandonedCartSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp14AbandonedCartSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp14AbandonedCartSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp14AbandonedCartEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp14AbandonedCartEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp14AbandonedCartEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp14AbandonedCartVoiceEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")
              ])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp14AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp14AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp14AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp14AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp14AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp14AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp14AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.ABANDONED_CART_DAY_30, sequenceArray) && (
        <>
          <SectionHeader {...page}>30 days after lead is created</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceAbandonedCartDay30Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceAbandonedCartDay30Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceAbandonedCartDay30Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp30AbandonedCartVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp30AbandonedCartSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp30AbandonedCartSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp30AbandonedCartSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp30AbandonedCartEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp30AbandonedCartEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp30AbandonedCartEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp30AbandonedCartVoiceEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")
              ])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp30AbandonedCartVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp30AbandonedCartSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplushasp30AbandonedCart1} />
              <TextAreaRow
                {...page}
                hideIf={IS_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplushasp30AbandonedCart2}
                enableSwitchVar={LocationVarKey.FMSplushasp30AbandonedCart2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusAbandonedCartsShortlinksEnabled, "1")}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp30AbandonedCart2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplushasp30AbandonedCart2Enabled}
              />
            </Section>
          </Section>
        </>
      )}
    </>
  );
}
